'use client';

import React, { useCallback } from 'react';
import Button from '@frontend/jetlend-web-ui/src/ui/inputs/Button/Button';
import { buildClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import { useActions } from '@frontend/jetlend-core/src/hooks/useActions';
import { CtaBlockSectionType } from '@app/models/sections/cta_block';
import HtmlMarkup from '@app/components/HtmlMarkup/HtmlMarkup';
import Image from '@app/components/Image/Image';
import styles from './CtaBlockSection.module.scss';
import { startRegistration } from '@app/ducks/common/registration';
import { sendEvent } from '@app/ducks/common/analytics';
import { ClientType } from '@app/models/common/common';

/**
 * Компонент для отображения секции с CTA блоком
 */
export default function CtaBlockSection({ section }: CtaBlockSectionType) {
    const startRegistrationAction = useActions(startRegistration);
    const sendEventAction = useActions(sendEvent);

    const didButtonClicked = useCallback((type: ClientType) => {
        sendEventAction(`${type}-button`);
        startRegistrationAction(type);
    }, [sendEventAction, startRegistrationAction]);

    return (
        <div className={buildClassNames(styles, ['container', section?.block_align])}>
            <div className={styles['content-container']}>
                <div className={styles['content']}>
                    <HtmlMarkup tag="h2" markup={section?.block_title} className={styles['title']} />
                    <HtmlMarkup markup={section?.block_title_description} className={styles['description']} />
                </div>
                <div className={styles['buttons-container']}>
                    <Button
                        text="Стать инвестором"
                        type="primary"
                        noSpacing
                        onClick={() => didButtonClicked(ClientType.INVESTOR)}
                    />
                    <Button
                        text="Привлечь финансирование"
                        type="primary"
                        noSpacing
                        onClick={() => didButtonClicked(ClientType.BORROWER)}
                    />
                </div>
            </div>
            <div />
            <div className={styles['image']}>
                <Image
                    fill
                    alt=""
                    src={section?.block_image}
                />
            </div>
        </div>
    );
};
